// apollo.ts
import { ApolloClient, InMemoryCache, HttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient as createWsClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

const HTTP_URL = `${process.env.REACT_APP_PUBLIC_BACKEND_API_URL}/graphql`;
const WS_URL = `${process.env.REACT_APP_PUBLIC_WS_URL}/graphql`;

export function makeApolloClient(getJwt: () => string) {
  const httpLink = new HttpLink({
    uri: HTTP_URL,
    // attach JWT on HTTP
    fetch: (input, init) => {
      const jwt = getJwt();
      init = init ?? {};
      init.headers = { ...(init.headers || {}), Authorization: `Bearer ${jwt}` };
      return fetch(input, init);
    },
  });

  // subscriptions over WebSocket (graphql-ws)
  const wsLink = new GraphQLWsLink(
    createWsClient({
      url: WS_URL,
      connectionParams: () => ({
        Authorization: `Bearer ${getJwt()}`,
      }),
      lazy: true,
      retryAttempts: 10,
    }),
  );

  // route query/mutation to HTTP, subscription to WS
  const link = split(
    ({ query }) => {
      const def = getMainDefinition(query);
      return def.kind === 'OperationDefinition' && def.operation === 'subscription';
    },
    wsLink,
    httpLink,
  );

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
}
